import theme from '../../lib/theme';

const { scale } = theme;

export default () => ({
  container: {
    padding: `0 0 ${scale.l}`,

    //  each block
    '& > *': {
      marginTop: scale.l,
    },

    '& > *:first-child': {
      paddingTop: `${scale.s}`,
      marginTop: 0,
    },
  },

  highImpact: {
    display: 'inline',
    width: 1,
    height: 1,
    position: 'absolute',
  },
  
  hiddenAd: {
    display: 'inline',
    width: 1,
    height: 1,
    position: 'absolute',
  },  
});
